import { makeStyles } from "@fluentui/react-components";

const useStyles = makeStyles({
    root: {
        display: "flex",
        flexDirection: "column",
        gap: "1rem"
    }
});

export default function FlightOps_Build_Overview() {
    const styles = useStyles();
    
    return (
        <div className={styles.root}>
            
        </div>
    );
}